import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Strike 2 — multi-tenant: attach the active workspace to every request so the
// backend isolates data by tenant. Falls back to the user's default workspace
// server-side when absent.
api.interceptors.request.use((config) => {
  try {
    const wid = localStorage.getItem("active_workspace_id");
    if (wid) {
      config.headers = config.headers || {};
      config.headers["X-Workspace-ID"] = wid;
    }
  } catch {
    /* localStorage unavailable — backend defaults to the user's workspace */
  }
  return config;
});

// Global 402 handler - if any gated endpoint says the subscription lapsed,
// bounce the user to the paywall. We skip this on the billing pages themselves.
api.interceptors.response.use(
  (r) => r,
  (error) => {
    if (error?.response?.status === 402) {
      const path = window.location.pathname;
      if (
        !path.startsWith("/paywall") &&
        !path.startsWith("/billing") &&
        !path.startsWith("/login")
      ) {
        window.location.replace("/paywall");
      }
    }
    // Strike 2 — a stale/foreign X-Workspace-ID (e.g. left over from a previous
    // session) yields a membership 403. Clear it and reload ONCE; with no header
    // the backend falls back to the default workspace so this can never loop.
    if (error?.response?.status === 403) {
      const detail = error?.response?.data?.detail;
      const isWsErr =
        typeof detail === "string" &&
        detail.toLowerCase().includes("member of this workspace");
      let hadWid = false;
      try {
        hadWid = !!localStorage.getItem("active_workspace_id");
      } catch {
        hadWid = false;
      }
      if (isWsErr && hadWid) {
        try {
          localStorage.removeItem("active_workspace_id");
        } catch {
          /* ignore */
        }
        window.location.reload();
        return new Promise(() => {});
      }
    }
    return Promise.reject(error);
  },
);

export default api;
